{
  "clientReport": "Client Report",
  "nameTemplate": "{{name}} Template",
  "editor": "Editor",
  "frequency": "Frequency",
  "frequencyTitle": "Report generation frequency",
  "oneTimeReportTitle": "Generate a one-time report",
  "rules": "Rules",
  "settings": "Settings",
  "publish": "publish",
  "frequencies": {
    "weekly": "Weekly",
    "onceAWeek": "Once a week",
    "dayOfNextWeek": "day of the next week (1-7 Monday to Sunday)",
    "monthly": "Monthly",
    "onceAMonth": "Once a Month",
    "dayOfNextMonth": "day of the next month (1-28)",
    "quarterly": "Quarterly",
    "onceAQuarter": "Once a Quarter",
    "dayOfNextQuarter": "day of the first month of next quarter (1-28)",
    "yearly": "Yearly",
    "onceAYear": "Once a Year",
    "dayOfNextYear": "day of the January next year (1-28)",
    "outOfBounds": "Out of Bounds",
    "one_time": "One-time",
    "oneTimeRange": "A one-time date range",
    "oneTimeStart": "Start Date",
    "oneTimeEnd": "End Date"
  },
  "comparisons": {
    "EQUALS": "Equals",
    "NOT_EQUALS": "NOT_EQUALS",
    "INCLUDES": "INCLUDES",
    "NOT_INCLUDES": "NOT_INCLUDES",
    "IN": "IN",
    "NOT_IN": "NOT_IN",
    "GREATER_THAN": "GREATER_THAN",
    "LESS_THAN": "LESS_THAN",
    "GREATER_THAN_AGO": "GREATER_THAN_AGO",
    "LESS_THAN_AGO": "LESS_THAN_AGO"
  },
  "addRule": "Add Rule",
  "edit": "Edit",
  "variablesAvailableForThisTemplate": "Variables available for this template",
  "savedSuccessfully": "Template successfully saved",
  "editModal": {
    "title": "Edit Client Report Template",
    "type": "Type",
    "description": "Description",
    "name": "Name"
  },
  "newModal": {
    "title": "New Client Report Template",
    "objectType": "Association",
    "type": "Type",
    "name": "Name",
    "reportType": "Report Type",
    "frequency": "Frequency",
    "reportTypes": {
      "HTML": "HTML",
      "PAGE_CONFIGURATION": "Page Configuration"
    }
  },
  "updateState": {
    "activate": "Activate",
    "deactivate": "Deactivate",
    "archive": "Archive",
    "review": "Review"
  },
  "settingsTab": {
    "coverPage": {
      "settingsTitle": "Cover Page Details",
      "title": "Title",
      "subtitle": "Subtitle",
      "disableBrandColor": "Disable Brand Color",
      "enableCompanyLogo": "Enable Company Logo",
      "enablePreparedBy": "Enable Prepared By",
      "preparedBy": "Prepared By",
      "enabled": "Enable Cover Page"
    },
    "footer": {
      "settingsTitle": "Footer Details",
      "text": "Text",
      "enableOnCoverPage": "Enable on Cover Page",
      "enableAlternateCoverPageText": "Enable Alternate Cover Page Text",
      "alternateCoverPageText": "Alternate Cover Page Text",
      "enabled": "Enable Footer"
    },
    "header": {
      "settingsTitle": "Header Details",
      "text": "Text",
      "enableOnCoverPage": "Enable on Cover Page",
      "enableAlternateCoverPageText": "Enable Alternate Cover Page Text",
      "alternateCoverPageText": "Alternate Cover Page Text",
      "enabled": "Enable Header"
    },
    "tableOfContents": {
      "settingsTitle": "Table of Contents Details",
      "title": "Title",
      "enabled": "Enable Table of Contents"
    },
    "general": {
      "settingsTitle": "General Details",
      "brandColor": "Brand Color"
    }
  }
}
